import React from 'react';
import { motion } from 'framer-motion';

const PageHeader = ({ title, titleAccent, subtitle, bgImage }) => {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      {bgImage && (
        <div className="absolute inset-0">
          <img src={bgImage} alt="" className="w-full h-full object-cover opacity-15" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#111111] via-[#111111]/80 to-[#111111]" />
        </div>
      )}

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-[#F5F0E8] leading-tight"
        >
          {title}{' '}
          {titleAccent && <span className="italic text-[#D4A843]">{titleAccent}</span>}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-[#8A8070] text-base md:text-lg mt-5 max-w-xl mx-auto"
          >
            {subtitle}
          </motion.p>
        )}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="w-12 h-[2px] bg-[#D4A843] mt-6 mx-auto"
        />
      </div>
    </section>
  );
};

export default PageHeader;
